import _extends from "@babel/runtime/helpers/extends";
import _jsx from "@babel/runtime/helpers/jsx";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["classes", "tabs", "className", "tabIndicatorProps"],
  _excluded2 = ["label", "tabClassName", "linkTo", "value"];
var _dec, _class, _class2;
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import _ from 'lodash';
import Url from 'url-parse';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import AppContext from '../../../context';
import Link from '../../Link';
import s from './presetsTabsScss/Primary.scss';
var LinkedTabs = (_dec = withStyles(s), _dec(_class = (_class2 = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(LinkedTabs, _React$PureComponent);
  var _super = _createSuper(LinkedTabs);
  function LinkedTabs() {
    _classCallCheck(this, LinkedTabs);
    return _super.apply(this, arguments);
  }
  _createClass(LinkedTabs, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        classes = _this$props.classes,
        tabs = _this$props.tabs,
        className = _this$props.className,
        tabIndicatorProps = _this$props.tabIndicatorProps,
        rest = _objectWithoutProperties(_this$props, _excluded);
      var _this$context = this.context,
        path = _this$context.path,
        organizationSlug = _this$context.organizationSlug,
        locale = _this$context.locale;
      var currentTabIndex = _.findIndex(tabs, function (t) {
        return new Url("/".concat(locale).concat(organizationSlug ? "/".concat(organizationSlug) : '').concat(t.linkTo)).pathname === path;
      });
      if (this.props.currentTabIndex !== -1) {
        currentTabIndex = this.props.currentTabIndex;
      }
      return /*#__PURE__*/_jsx("nav", {}, void 0, /*#__PURE__*/React.createElement(Tabs, _extends({
        variant: "scrollable",
        scrollButtons: "on",
        textColor: "primary",
        value: currentTabIndex === -1 ? 0 : currentTabIndex,
        TabIndicatorProps: _objectSpread({
          className: classes.tabsIndicator
        }, tabIndicatorProps),
        className: cx(classes.root, className),
        classes: {
          root: classes.root,
          scrollButtons: classes.scrollButtons
        },
        onChange: this.onChange
      }, rest), _.map(tabs, function (tab, i) {
        if (!tab) {
          return null;
        }
        var label = tab.label,
          tabClassName = tab.tabClassName,
          linkTo = tab.linkTo,
          value = tab.value,
          other = _objectWithoutProperties(tab, _excluded2);
        return /*#__PURE__*/React.createElement(Tab, _extends({
          label: currentTabIndex === i ? /*#__PURE__*/_jsx(Typography, {
            component: "h1",
            className: s.activeTab
          }, void 0, label) : label,
          key: linkTo + i,
          classes: {
            root: classes.tabRoot,
            textColorPrimary: classes.tabLabel
          },
          className: tabClassName,
          component: Link,
          value: value || i,
          to: linkTo
        }, other));
      })));
    }
  }]);
  return LinkedTabs;
}(React.PureComponent), _defineProperty(_class2, "contextType", AppContext), _defineProperty(_class2, "defaultProps", {
  className: '',
  tabIndicatorProps: {},
  currentTabIndex: -1,
  classes: {
    root: s.root,
    scrollButtons: s.scrollButtons,
    tabsIndicator: s.tabsIndicator,
    tabRoot: s.tabRoot,
    tabLabel: s.tabLabel
  }
}), _class2)) || _class);
export { LinkedTabs as default };